export const PHONE_NUMBER_PATTERN = {
  value: /^(\+|00)[1-9]\d{1,14}$/,
  message: 'Ungültige Telefonnummer. Format: +49, 0049, keine Leer-/Sonderzeichen.',
};
